import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output} from '@angular/core';
import {AbstractControl} from "@angular/forms";

@Component({
  selector: 'app-comments-dialog',
  templateUrl: './comments-dialog.component.html',
  styleUrls: ['./comments-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CommentsDialogComponent {
  @Input() public popupVisible: boolean = false;
  @Input() public control: AbstractControl | null = null;
  @Output() public closeEvent = new EventEmitter();

  constructor() { }

  public close() {
    this.popupVisible = false;
  }

  public hidden(){
    this.closeEvent.emit();
  }
}
